/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { getTableConfiguration } from '../../../../utils/universalTracker'
import { BaseInputProps } from './InputProps';
import { ValueTable, TableInputProps, TableValueDataData } from './table/InputInterface';
import SingleRowTableInput from './table/SingleRowTableInput';
import MultiRowTableInput from './table/MultiRowTableInput';
import './TableInput.scss';
import { QUESTION } from '../../../../constants/terminology';

export default function TableInput(props: BaseInputProps) {

  const { universalTracker } = props;
  const tableConfiguration: ValueTable | undefined = getTableConfiguration(universalTracker)
  const calculationColumns = React.useMemo(() => {
    if (!tableConfiguration) {
      return [];
    }
    return tableConfiguration.columns.filter((c) => c.calculation?.formula)
  }, [tableConfiguration])

  const visibilityRuleColumns = React.useMemo(() => {
    if (!tableConfiguration) {
      return [];
    }
    const columns = tableConfiguration.columns.filter((c) => c.visibilityRule?.formula)
    return columns
  }, [tableConfiguration])

  if (!tableConfiguration || !props.table) {
    return <div className='input-group'>
      <span>Unsupported {QUESTION.SINGULAR}</span>
    </div>;
  }

  const valueDataData = props.valueDataData
  if (valueDataData && !Array.isArray(valueDataData)) {
    return <div className='input-group'>
      <span>Unsupported table {QUESTION.SINGULAR}</span>
    </div>;
  }

  const mergedProps: TableInputProps = {
    ...props,
    valueDataData: valueDataData as TableValueDataData,
    calculationColumns,
    visibilityRuleColumns,
    tableConfiguration,
  }

  if (tableConfiguration.validation?.maxRows === 1) {
    return <SingleRowTableInput {...mergedProps} />
  }

  return <MultiRowTableInput {...mergedProps} />
}
